import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  InventoryAggregateEntities,
  InventoryAggregateModel,
  buildMMYSubmodelTypeAmountsPath,
} from 'client/data/models/inventory-aggregate';
import { buildUsedTmvPricingPath, getUsedBaseStylePath, VehicleModel } from 'client/data/models/vehicle-v2';
import { VisitorModel } from 'client/data/models/visitor';
import { getPriceRangeString } from 'site-modules/shared/utils/price-utils';
import { isUnknownZip } from 'site-modules/shared/utils/location';
import { getUsedVehiclePriceRange } from 'site-modules/shared/utils/core-page/pricing';

export function UsedVehiclePriceUI({ submodelSlug, submodelAmounts, priceClassName, labelClassName, usedTmv }) {
  const { min, max } = getUsedVehiclePriceRange({ submodelAmounts, submodelSlug, usedTmv });
  const hasPrice = !!(min && max);
  const vehiclePrice = hasPrice && getPriceRangeString(min, max);
  const isInventoryPrice = !!get(submodelAmounts, `priceRanges["${submodelSlug}"]`) || !usedTmv;
  const priceLabel = isInventoryPrice ? `List Price${hasPrice && min === max ? '' : ' Range'}` : 'List Price Estimate';

  return (
    <Fragment>
      <div className={labelClassName}>{priceLabel}</div>
      <div className={classnames('d-flex justify-content-between', priceClassName)}>
        {hasPrice ? vehiclePrice : 'Not Available'}
      </div>
    </Fragment>
  );
}
UsedVehiclePriceUI.propTypes = {
  submodelSlug: PropTypes.string.isRequired,
  submodelAmounts: InventoryAggregateEntities.MMYSubmodelTypeAmounts,
  priceClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  usedTmv: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
};

UsedVehiclePriceUI.defaultProps = {
  submodelAmounts: null,
  priceClassName: 'heading-3',
  labelClassName: 'label',
  usedTmv: null,
};

export const UsedVehiclePriceWrapper = connectToModel(UsedVehiclePriceUI, {
  usedTmv: bindToPath(
    ({ usedBaseStyle, visitorLocation, submodelAmounts, submodelSlug }) =>
      usedBaseStyle &&
      (isUnknownZip(visitorLocation) || (submodelAmounts && !get(submodelAmounts, `priceRanges["${submodelSlug}"]`))) &&
      buildUsedTmvPricingPath(get(usedBaseStyle, 'usedDefaultStyle.id')),
    VehicleModel,
    data => ({
      min: get(data, 'ROUGH.Current.totalWithOptions.usedTmvRetail', 0),
      max: get(data, 'OUTSTANDING.Current.totalWithOptions.usedTmvRetail', 0),
    })
  ),
});

export const UsedVehiclePrice = connectToModel(UsedVehiclePriceWrapper, {
  submodelAmounts: bindToPath(({ params }) => buildMMYSubmodelTypeAmountsPath(params), InventoryAggregateModel),
  usedBaseStyle: bindToPath(({ params }) => getUsedBaseStylePath(params), VehicleModel),
  visitorLocation: bindToPath('location', VisitorModel),
});
